<div class="dashboard-container px-5">
  <div class="layout-fr gap-3 pt-4">
    @if (selectIsLoadingPortfolio$ | async) {
      <p-skeleton width="100%" height="80vh" />
    } @else {
      @if (dashboardWidgets$ | async; as dashboardWidgets) {
        <div class="layout-fr gap-3">
          @for (widget of dashboardWidgets; track widget) {
            <div>
              <cp-widget-container [widget]="widget" />
            </div>
          }
        </div>
      }
    }
  </div>
</div>
